import { LastPromptSignInPersistenceContext } from "~applications";
import { createStaticContextProvider, lazyValue } from "~utils";

export const LastPromptSignInPersistenceProvider = createStaticContextProvider(
  LastPromptSignInPersistenceContext,
  lazyValue(() =>
    import("./last-prompt-sign-in-persistence").then(
      (module) => module.lastPromptSignInPersistence,
    ),
  ),
);
